// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcw-message {
  margin: 10px;
  display: flex;
  white-space: pre-wrap;
  word-wrap: break-word
}

.rcw-message-client {
  flex-direction: row-reverse
}

.rcw-timestamp {
  color: #222;
  font-size: 10px !important;
  margin-top: 5px !important;
}

.rcw-client {
  display: flex;
  flex-direction: column;
  margin-left: auto
}

.rcw-client .rcw-message-text {
  color: #222;

  border-radius: 10px;
  max-width: 215px;
  padding: 15px;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word
}

.rcw-client .rcw-timestamp {
  align-self: flex-end !important;
}

.rcw-response {
  display: flex;
  flex-direction: column;
  align-items: flex-start
}

.rcw-response .rcw-message-text {
  color: #222;
  background-color: #f4f7f9;
  border-radius: 10px;
  max-width: 215px;
  padding: 15px;
  text-align: left
}

.rcw-message-text p {

  display: block !important;
  margin-block-start: 1em !important;
  margin-block-end: 1em !important;
  margin-inline-start: 0px !important;
  margin-inline-end: 0px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
  -webkit-font-smoothing: antialiased !important;
  color: #222 !important;
  margin: 0 !important;
}

.rcw-message-text img {
  color: #222;
  width: 100%;
  object-fit: contain
}

.rcw-avatar {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-right: 10px
}

.rcw-avatar-client {
  margin: 0 0 0 10px
}

.rcw-snippet {
  background-color: #f4f7f9;
  border-radius: 10px;
  max-width: 215px;
  padding: 15px;
  text-align: left
}

.rcw-snippet-title {
  margin: 0
}

.rcw-link {
  font-size: 12px
}

.quick-button {
  background: none;
  border-radius: 15px;

  font-weight: 700;
  padding: 5px 10px;
  cursor: pointer;
  outline: 0
}

.quick-button:active {

  color: #fff
}

.rcw-conversation-container .rcw-header {

  border-radius: 10px 10px 0 0 !important;
  color: #fff !important;
  display: flex !important;
  flex-direction: column !important;
  text-align: center !important;
  padding: 15px 0 25px !important;
}

.rcw-conversation-container .rcw-title {
  font-weight: bold;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  font-size: 24px !important;
  margin: 0 !important;
  padding: 15px 0 !important;
}

.rcw-conversation-container .rcw-close-button {
  display: none
}

.rcw-conversation-container .avatar {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-right: 10px;
  vertical-align: middle
}

.rcw-full-screen .rcw-header {
  border-radius: 0;
  flex-shrink: 0;
  position: relative
}

.rcw-full-screen .rcw-title {
  padding: 0 0 15px
}

.rcw-full-screen .rcw-close-button {
  border: 0;
  display: block;
  position: absolute;
  right: 10px;
  top: 20px;
  width: 40px
}

.rcw-full-screen .rcw-close {
  width: 20px;
  height: 20px
}

@media screen and (max-width:800px) {
  .rcw-conversation-container {
    max-width: 100vw !important;
    /*margin-top: 80px;
    margin-bottom: 10px;*/
  }

  .rcw-conversation-container .rcw-header {
    border-radius: 0;
    flex-shrink: 0;
    position: relative
  }

  input[type="text"] {
    font-size: 16px;
  }

  .rcw-conversation-container .rcw-title {
    padding: 0 0 15px
  }

  .rcw-conversation-container .rcw-close-button {
    border: 0;
    display: block;
    position: absolute;
    right: 10px;
    top: 20px;
    width: 40px
  }

  .rcw-conversation-container .rcw-close {
    cursor: pointer;
    width: 20px;
    height: 20px
  }
}

.loader {
  margin: 10px;
  display: none
}

.loader.active {
  display: flex
}

.loader-container {
  background-color: #f4f7f9;
  border-radius: 10px;
  padding: 15px;
  max-width: 215px;
  text-align: left
}

.loader-dots {
  display: inline-block;
  height: 4px;
  width: 4px;
  border-radius: 50%;
  background: grey;
  margin-right: 2px;
  animation: bounce .5s ease infinite alternate
}

.loader-dots:first-child {
  animation-delay: .2s
}

.loader-dots:nth-child(2) {
  animation-delay: .3s
}

.loader-dots:nth-child(3) {
  animation-delay: .4s
}

@keyframes bounce {
  0% {
    transform: translateY(0)
  }

  to {
    transform: translateY(5px)
  }
}

.rcw-messages-container {
  background-color: #fff;
  height: 50vh;
  max-height: 410px;
  overflow-y: scroll;
  padding-top: 10px;
  -webkit-overflow-scrolling: touch
}

.rcw-full-screen .rcw-messages-container {
  height: 100%;
  max-height: none
}

@media screen and (max-width:800px) {
  .rcw-messages-container {
    height: 100%;
    max-height: none
  }
}

.rcw-sender {
  align-items: flex-end !important;
  background-color: #f4f7f9 !important;
  border-radius: 0 0 10px 10px !important;
  display: flex !important;
  height: max-content !important;
  max-height: 95px !important;
  min-height: 45px !important;
  overflow: hidden !important;
  padding: 10px !important;
  position: relative !important;
}

body {
  letter-spacing: inherit;
  line-height: inherit;
}

.rcw-sender.expand {
  height: 55px
}

.rcw-new-message {
  background-color: #fff !important;
  border: 0 !important;
  border-radius: 5px !important;
  padding: 10px 5px !important;
  resize: none !important;
  width: calc(100% - 75px) !important;
}

.rcw-new-message:focus {
  outline: none
}

.rcw-new-message.expand {
  height: 40px
}

.rcw-input {
  display: block;
  height: 100%;
  line-height: 20px;
  max-height: 78px;
  overflow-y: auto;
  -webkit-user-select: text;
  user-select: text;
  white-space: pre-wrap;
  word-wrap: break-word;
  -webkit-user-modify: read-write !important;
  -webkit-line-break: after-white-space !important;
  color: #222;
  outline: inherit;
  outline-offset: inherit;
  box-shadow: inherit;
}

.rcw-input.focus-visible,
.rcw-input:focus-visible {
  outline: none !important;
}

.rcw-input[placeholder]:empty:before {
  content: attr(placeholder) !important;
  color: grey !important;
}

a:empty,
ul:empty,
dl:empty,
div:empty,
section:empty,
article:empty,
p:empty,
h1:empty,
h2:empty,
h3:empty,
h4:empty,
h5:empty,
h6:empty {
  display: inherit;
}

.rcw-picker-btn,
.rcw-send {
  background: #f4f7f9;
  border: 0;
  cursor: pointer
}

.rcw-picker-btn .rcw-send-icon,
.rcw-send .rcw-send-icon {
  height: 25px
}

.rcw-message-disable {
  background-color: #f4f7f9;
  cursor: not-allowed
}

@media screen and (max-width:800px) {
  .rcw-sender {
    border-radius: 0;
    flex-shrink: 0
  }
}

.quick-buttons-container {
  background: #fff;
  overflow-x: auto;
  white-space: nowrap;
  padding: 10px
}

.quick-buttons-container .quick-buttons {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center
}

.quick-buttons-container .quick-buttons .quick-list-button {
  display: inline-block;
  margin-right: 10px
}

@media screen and (max-width:800px) {
  .quick-buttons-container {
    padding-bottom: 15px
  }
}

.emoji-mart,
.emoji-mart * {
  box-sizing: border-box;
  line-height: 1.15
}

.emoji-mart {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  font-size: 16px;
  display: inline-block;
  color: #222427;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  background: #fff
}

.emoji-mart .emoji-mart-emoji {
  padding: 6px
}

.emoji-mart-bar {
  border: 0 solid #d9d9d9
}

.emoji-mart-bar:first-child {
  border-bottom-width: 1px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px
}

.emoji-mart-bar:last-child {
  border-top-width: 1px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px
}

.emoji-mart-anchors {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 6px;
  line-height: 0
}

.emoji-mart-anchor {
  position: relative;
  display: block;
  flex: 1 1 auto;
  color: #858585;
  text-align: center;
  padding: 12px 4px;
  overflow: hidden;
  transition: color .1s ease-out;
  margin: 0;
  box-shadow: none;
  background: none;
  border: none
}

.emoji-mart-anchor:focus {
  outline: 0
}

.emoji-mart-anchor-selected,
.emoji-mart-anchor:focus,
.emoji-mart-anchor:hover {
  color: #464646
}

.emoji-mart-anchor-selected .emoji-mart-anchor-bar {
  bottom: 0
}

.emoji-mart-anchor-bar {
  position: absolute;
  bottom: -3px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #464646
}

.emoji-mart-anchors i {
  display: inline-block;
  width: 100%;
  max-width: 22px
}

.emoji-mart-anchors img,
.emoji-mart-anchors svg {
  fill: currentColor;
  height: 18px;
  width: 18px
}

.emoji-mart-scroll {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 270px;
  padding: 0 6px 6px;
  will-change: transform
}

.emoji-mart-search {
  margin-top: 6px;
  padding: 0 6px;
  position: relative
}

.emoji-mart-search input {
  font-size: 16px;
  display: block;
  width: 100%;
  padding: 5px 25px 6px 10px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
  outline: 0
}

.emoji-mart-search input,
.emoji-mart-search input::-webkit-search-cancel-button,
.emoji-mart-search input::-webkit-search-decoration,
.emoji-mart-search input::-webkit-search-results-button,
.emoji-mart-search input::-webkit-search-results-decoration {
  -webkit-appearance: none
}

.emoji-mart-search-icon {
  position: absolute;
  top: 7px;
  right: 11px;
  z-index: 2;
  padding: 2px 5px 1px;
  border: none;
  background: none
}

.emoji-mart-category .emoji-mart-emoji span {
  z-index: 1;
  position: relative;
  text-align: center;
  cursor: default
}

.emoji-mart-category .emoji-mart-emoji:hover:before {
  z-index: 0;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f4f4f4;
  border-radius: 100%
}

.emoji-mart-category-label {
  z-index: 2;
  position: relative;
  position: sticky;
  top: 0
}

.emoji-mart-category-label span {
  display: block;
  width: 100%;
  font-weight: 500;
  padding: 5px 6px;
  background-color: #fff;
  background-color: hsla(0, 0%, 100%, .95)
}

.emoji-mart-category-list {
  margin: 0;
  padding: 0
}

.emoji-mart-category-list li {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-block
}

.emoji-mart-emoji {
  position: relative;
  display: inline-block;
  font-size: 0;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  box-shadow: none
}

.emoji-mart-emoji-native {
  font-family: Segoe UI Emoji, Segoe UI Symbol, Segoe UI, Apple Color Emoji, Twemoji Mozilla, Noto Color Emoji, Android Emoji
}

.emoji-mart-no-results {
  font-size: 14px;
  text-align: center;
  padding-top: 70px;
  color: #858585
}

.emoji-mart-no-results-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%
}

.emoji-mart-no-results .emoji-mart-category-label {
  display: none
}

.emoji-mart-no-results .emoji-mart-no-results-label {
  margin-top: .2em
}

.emoji-mart-no-results .emoji-mart-emoji:hover:before {
  content: none
}

.emoji-mart-preview {
  position: relative;
  height: 70px
}

.emoji-mart-preview-data,
.emoji-mart-preview-emoji,
.emoji-mart-preview-skins {
  position: absolute;
  top: 50%;
  transform: translateY(-50%)
}

.emoji-mart-preview-emoji {
  left: 12px
}

.emoji-mart-preview-data {
  left: 68px;
  right: 12px;
  word-break: break-all
}

.emoji-mart-preview-skins {
  right: 30px;
  text-align: right
}

.emoji-mart-preview-skins.custom {
  right: 10px;
  text-align: right
}

.emoji-mart-preview-name {
  font-size: 14px
}

.emoji-mart-preview-shortname {
  font-size: 12px;
  color: #888
}

.emoji-mart-preview-emoticon+.emoji-mart-preview-emoticon,
.emoji-mart-preview-shortname+.emoji-mart-preview-emoticon,
.emoji-mart-preview-shortname+.emoji-mart-preview-shortname {
  margin-left: .5em
}

.emoji-mart-preview-emoticon {
  font-size: 11px;
  color: #bbb
}

.emoji-mart-title span {
  display: inline-block;
  vertical-align: middle
}

.emoji-mart-title .emoji-mart-emoji {
  padding: 0
}

.emoji-mart-title-label {
  color: #999a9c;
  font-size: 26px;
  font-weight: 300
}

.emoji-mart-skin-swatches {
  font-size: 0;
  padding: 2px 0;
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  background-color: #fff
}

.emoji-mart-skin-swatches.custom {
  font-size: 0;
  border: none;
  background-color: #fff
}

.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {
  width: 16px;
  padding: 0 2px
}

.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {
  opacity: .75
}

.emoji-mart-skin-swatch {
  display: inline-block;
  width: 0;
  vertical-align: middle;
  transition-property: width, padding;
  transition-duration: .125s;
  transition-timing-function: ease-out
}

.emoji-mart-skin-swatch:first-child {
  transition-delay: 0s
}

.emoji-mart-skin-swatch:nth-child(2) {
  transition-delay: .03s
}

.emoji-mart-skin-swatch:nth-child(3) {
  transition-delay: .06s
}

.emoji-mart-skin-swatch:nth-child(4) {
  transition-delay: .09s
}

.emoji-mart-skin-swatch:nth-child(5) {
  transition-delay: .12s
}

.emoji-mart-skin-swatch:nth-child(6) {
  transition-delay: .15s
}

.emoji-mart-skin-swatch.selected {
  position: relative;
  width: 16px;
  padding: 0 2px
}

.emoji-mart-skin-swatch.selected:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  margin: -2px 0 0 -2px;
  background-color: #fff;
  border-radius: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity .2s ease-out
}

.emoji-mart-skin-swatch.custom {
  display: inline-block;
  width: 0;
  height: 38px;
  overflow: hidden;
  vertical-align: middle;
  transition-property: width, height;
  transition-duration: .125s;
  transition-timing-function: ease-out;
  cursor: default
}

.emoji-mart-skin-swatch.custom.selected {
  position: relative;
  width: 36px;
  height: 38px;
  padding: 0 2px 0 0
}

.emoji-mart-skin-swatch.custom.selected:after {
  content: "";
  width: 0;
  height: 0
}

.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {
  background-color: #f4f4f4;
  border-radius: 10%
}

.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {
  width: 36px;
  height: 38px;
  padding: 0 2px 0 0
}

.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {
  opacity: .75
}

.emoji-mart-skin-text.opened {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  color: #888;
  font-size: 11px;
  padding: 5px 2px;
  width: 95px;
  height: 40px;
  border-radius: 10%;
  background-color: #fff
}

.emoji-mart-skin {
  display: inline-block;
  width: 100%;
  padding-top: 100%;
  max-width: 12px;
  border-radius: 100%
}

.emoji-mart-skin-tone-1 {
  background-color: #ffc93a
}

.emoji-mart-skin-tone-2 {
  background-color: #fadcbc
}

.emoji-mart-skin-tone-3 {
  background-color: #e0bb95
}

.emoji-mart-skin-tone-4 {
  background-color: #bf8f68
}

.emoji-mart-skin-tone-5 {
  background-color: #9b643d
}

.emoji-mart-skin-tone-6 {
  background-color: #594539
}

.emoji-mart-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0
}

.emoji-mart-dark {
  color: #fff;
  background-color: #222
}

.emoji-mart-dark,
.emoji-mart-dark .emoji-mart-bar {
  border-color: #555453
}

.emoji-mart-dark .emoji-mart-search input {
  color: #fff;
  border-color: #555453;
  background-color: #2f2f2f
}

.emoji-mart-dark .emoji-mart-search-icon svg {
  fill: #fff
}

.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {
  background-color: #444
}

.emoji-mart-dark .emoji-mart-category-label span {
  background-color: #222;
  color: #fff
}

.emoji-mart-dark .emoji-mart-skin-swatches {
  border-color: #555453;
  background-color: #222
}

.emoji-mart-dark .emoji-mart-anchor-selected,
.emoji-mart-dark .emoji-mart-anchor:focus,
.emoji-mart-dark .emoji-mart-anchor:hover {
  color: #bfbfbf
}

.rcw-conversation-container {
  border-radius: 10px;
  box-shadow: 0 2px 10px 1px #b5b5b5;
  min-width: 370px;
  max-width: 90vw;
  position: relative
}

.rcw-conversation-container.active {
  opacity: 1;
  transform: translateY(0);
  transition: opacity .3s ease, transform .3s ease
}

.rcw-conversation-container.hidden {
  z-index: -1;
  pointer-events: none;
  opacity: 0;
  transform: translateY(10px);
  transition: opacity .3s ease, transform .3s ease
}

.rcw-conversation-resizer {
  cursor: col-resize;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 5px
}

.emoji-mart-preview {
  display: none
}

.rcw-full-screen .rcw-conversation-container {
  display: flex;
  flex-direction: column;
  height: 100%
}

@media screen and (max-width:800px) {
  .rcw-conversation-container {
    display: flex;
    flex-direction: column;
    height: 100%
  }
}

.rcw-launcher .rcw-badge {
  position: fixed;
  top: -10px;
  right: -5px;
  background-color: red;
  color: #fff;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
  border-radius: 50%
}

.rcw-launcher {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: .5s;
  -webkit-animation-name: slide-in;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-delay: 0;
  -moz-animation-duration: .5s;
  -moz-animation-name: slide-in;
  -moz-animation-fill-mode: forwards;
  animation-delay: 0;
  animation-duration: .5s;
  animation-name: slide-in;
  animation-fill-mode: forwards;
  align-self: flex-end;
  border: 0;
  border-radius: 50%;
  box-shadow: 0 2px 10px 1px #b5b5b5;
  height: 60px;
  margin-top: 10px;
  cursor: pointer;
  width: 60px
}

.rcw-launcher:focus {
  outline: none
}

.rcw-open-launcher {
  -webkit-animation-delay: 0;
  -webkit-animation-duration: .5s;
  -webkit-animation-name: rotation-rl;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-delay: 0;
  -moz-animation-duration: .5s;
  -moz-animation-name: rotation-rl;
  -moz-animation-fill-mode: forwards;
  animation-delay: 0;
  animation-duration: .5s;
  animation-name: rotation-rl;
  animation-fill-mode: forwards
}

.rcw-close-launcher {
  width: 20px;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: .5s;
  -webkit-animation-name: rotation-lr;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-delay: 0;
  -moz-animation-duration: .5s;
  -moz-animation-name: rotation-lr;
  -moz-animation-fill-mode: forwards;
  animation-delay: 0;
  animation-duration: .5s;
  animation-name: rotation-lr;
  animation-fill-mode: forwards
}

@media screen and (max-width:800px) {
  .rcw-launcher {
    bottom: 0;
    margin: 20px;
    position: fixed;
    right: 0
  }

  .rcw-hide-sm {
    display: none
  }
}

.rcw-previewer-container {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .75);
  overflow: hidden;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0
}

.rcw-previewer-container .rcw-previewer-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  transition: all .3s ease
}

.rcw-previewer-container .rcw-previewer-tools {
  position: fixed;
  right: 16px;
  bottom: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

.rcw-previewer-container .rcw-previewer-button {
  padding: 0;
  margin: 16px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, .3);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  background-color: #fff;
  border: none
}

.rcw-previewer-container .rcw-previewer-close-button {
  position: absolute;
  right: 0;
  top: 0
}

.rcw-previewer-container .rcw-previewer-veil {
  width: 100%;
  height: 100%;
  overflow: scroll;
  position: relative
}

@keyframes rotation-lr {
  0% {
    transform: rotate(-90deg)
  }

  to {
    transform: rotate(0)
  }
}

@keyframes rotation-rl {
  0% {
    transform: rotate(90deg)
  }

  to {
    transform: rotate(0)
  }
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(10px)
  }

  to {
    opacity: 1;
    transform: translateY(0)
  }
}

@keyframes slide-out {
  0% {
    opacity: 1;
    transform: translateY(0)
  }

  to {
    opacity: 0;
    transform: translateY(10px)
  }
}

.rcw-widget-container {
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin: 0 20px 20px 0;
  position: fixed;
  right: 0;
  z-index: 9999
}

.rcw-full-screen {
  height: 100vh;
  margin: 0;
  max-width: none;
  width: 100%
}

@media screen and (max-width:800px) {
  .rcw-widget-container {
    height: 100%;
    height: 100vh;
    margin: 0;
    max-width: none;
    width: 100%
  }
}

.rcw-previewer .rcw-message-img {
  cursor: pointer
}

.rcw-close-widget-container {
  height: max-content;
  width: max-content
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,WAAW;;EAEX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb;AACF;;AAEA;;EAEE,yBAAyB;EACzB,kCAAkC;EAClC,gCAAgC;EAChC,mCAAmC;EACnC,iCAAiC;EACjC,yKAAyK;EACzK,8CAA8C;EAC9C,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EAEX;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;;EAEnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;;EAEE;AACF;;AAEA;;EAEE,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,0EAA0E;EAC1E,0BAA0B;EAC1B,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B;yBACqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;EACF;;EAEA;IACE,SAAS;IACT,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT;EACF;;EAEA;IACE,eAAe;IACf,WAAW;IACX;EACF;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAEjB;AACF;;AAEA;EAEE;AACF;;AAEA;EAEE;AACF;;AAEA;EAEE;AACF;;AAYA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE;IACE,YAAY;IACZ;EACF;AACF;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,uCAAuC;EACvC,wBAAwB;EAGxB,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE;AACF;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;EAC5B,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,0CAA0C;EAC1C,gDAAgD;EAChD,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;EAaE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;EACT;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;;EAEE,sBAAsB;EACtB;AACF;;AAEA;EACE,0EAA0E;EAC1E,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX;AACF;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB;AACF;;AAEA;;;;;EAKE;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAElB,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB;AACF;;AAEA;EACE,SAAS;EACT;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;;;EAGE,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,mCAAmC;EACnC,0BAA0B;EAC1B;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV;AACF;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,0BAA0B;EAC1B,oCAAoC;EACpC;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,WAAW;EACX,QAAQ;EACR;AACF;;AAEA;EACE,yBAAyB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sBAAsB;EACtB;AACF;;AAEA;EACE,qBAAqB;EACrB;AACF;;AAEA;;;EAGE;AACF;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,2BAA2B;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB;EACF;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,gCAAgC;EAChC,qCAAqC;EACrC,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,qCAAqC;EACrC,uBAAuB;EACvB,4BAA4B;EAC5B,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,+BAA+B;EAC/B,mCAAmC;EACnC,qCAAqC;EACrC,uBAAuB;EACvB,4BAA4B;EAC5B,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B;AACF;;AAEA;EACE;IACE,SAAS;IACT,YAAY;IACZ,eAAe;IACf;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,OAAO;EACP;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB;AACF;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB;AACF;;AAYA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAYA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAcA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAcA;EACE;IACE,UAAU;IACV;EACF;;EAEA;IACE,UAAU;IACV;EACF;AACF;;AAEA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,QAAQ;EACR;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,SAAS;IACT,eAAe;IACf;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EAGE,mBAAmB;EAGnB;AACF","sourcesContent":[".rcw-message {\n  margin: 10px;\n  display: flex;\n  white-space: pre-wrap;\n  word-wrap: break-word\n}\n\n.rcw-message-client {\n  flex-direction: row-reverse\n}\n\n.rcw-timestamp {\n  color: #222;\n  font-size: 10px !important;\n  margin-top: 5px !important;\n}\n\n.rcw-client {\n  display: flex;\n  flex-direction: column;\n  margin-left: auto\n}\n\n.rcw-client .rcw-message-text {\n  color: #222;\n\n  border-radius: 10px;\n  max-width: 215px;\n  padding: 15px;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word\n}\n\n.rcw-client .rcw-timestamp {\n  align-self: flex-end !important;\n}\n\n.rcw-response {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start\n}\n\n.rcw-response .rcw-message-text {\n  color: #222;\n  background-color: #f4f7f9;\n  border-radius: 10px;\n  max-width: 215px;\n  padding: 15px;\n  text-align: left\n}\n\n.rcw-message-text p {\n\n  display: block !important;\n  margin-block-start: 1em !important;\n  margin-block-end: 1em !important;\n  margin-inline-start: 0px !important;\n  margin-inline-end: 0px !important;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;\n  -webkit-font-smoothing: antialiased !important;\n  color: #222 !important;\n  margin: 0 !important;\n}\n\n.rcw-message-text img {\n  color: #222;\n  width: 100%;\n  -o-object-fit: contain;\n  object-fit: contain\n}\n\n.rcw-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  margin-right: 10px\n}\n\n.rcw-avatar-client {\n  margin: 0 0 0 10px\n}\n\n.rcw-snippet {\n  background-color: #f4f7f9;\n  border-radius: 10px;\n  max-width: 215px;\n  padding: 15px;\n  text-align: left\n}\n\n.rcw-snippet-title {\n  margin: 0\n}\n\n.rcw-link {\n  font-size: 12px\n}\n\n.quick-button {\n  background: none;\n  border-radius: 15px;\n\n  font-weight: 700;\n  padding: 5px 10px;\n  cursor: pointer;\n  outline: 0\n}\n\n.quick-button:active {\n\n  color: #fff\n}\n\n.rcw-conversation-container .rcw-header {\n\n  border-radius: 10px 10px 0 0 !important;\n  color: #fff !important;\n  display: flex !important;\n  flex-direction: column !important;\n  text-align: center !important;\n  padding: 15px 0 25px !important;\n}\n\n.rcw-conversation-container .rcw-title {\n  font-weight: bold;\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;\n  font-size: 24px !important;\n  margin: 0 !important;\n  padding: 15px 0 !important;\n}\n\n.rcw-conversation-container .rcw-close-button {\n  display: none\n}\n\n.rcw-conversation-container .avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 100%;\n  margin-right: 10px;\n  vertical-align: middle\n}\n\n.rcw-full-screen .rcw-header {\n  border-radius: 0;\n  flex-shrink: 0;\n  position: relative\n}\n\n.rcw-full-screen .rcw-title {\n  padding: 0 0 15px\n}\n\n.rcw-full-screen .rcw-close-button {\n  border: 0;\n  display: block;\n  position: absolute;\n  right: 10px;\n  top: 20px;\n  width: 40px\n}\n\n.rcw-full-screen .rcw-close {\n  width: 20px;\n  height: 20px\n}\n\n@media screen and (max-width:800px) {\n  .rcw-conversation-container {\n    max-width: 100vw !important;\n    /*margin-top: 80px;\n    margin-bottom: 10px;*/\n  }\n\n  .rcw-conversation-container .rcw-header {\n    border-radius: 0;\n    flex-shrink: 0;\n    position: relative\n  }\n\n  input[type=\"text\"] {\n    font-size: 16px;\n  }\n\n  .rcw-conversation-container .rcw-title {\n    padding: 0 0 15px\n  }\n\n  .rcw-conversation-container .rcw-close-button {\n    border: 0;\n    display: block;\n    position: absolute;\n    right: 10px;\n    top: 20px;\n    width: 40px\n  }\n\n  .rcw-conversation-container .rcw-close {\n    cursor: pointer;\n    width: 20px;\n    height: 20px\n  }\n}\n\n.loader {\n  margin: 10px;\n  display: none\n}\n\n.loader.active {\n  display: flex\n}\n\n.loader-container {\n  background-color: #f4f7f9;\n  border-radius: 10px;\n  padding: 15px;\n  max-width: 215px;\n  text-align: left\n}\n\n.loader-dots {\n  display: inline-block;\n  height: 4px;\n  width: 4px;\n  border-radius: 50%;\n  background: grey;\n  margin-right: 2px;\n  -webkit-animation: bounce .5s ease infinite alternate;\n  animation: bounce .5s ease infinite alternate\n}\n\n.loader-dots:first-child {\n  -webkit-animation-delay: .2s;\n  animation-delay: .2s\n}\n\n.loader-dots:nth-child(2) {\n  -webkit-animation-delay: .3s;\n  animation-delay: .3s\n}\n\n.loader-dots:nth-child(3) {\n  -webkit-animation-delay: .4s;\n  animation-delay: .4s\n}\n\n@-webkit-keyframes bounce {\n  0% {\n    transform: translateY(0)\n  }\n\n  to {\n    transform: translateY(5px)\n  }\n}\n\n@keyframes bounce {\n  0% {\n    transform: translateY(0)\n  }\n\n  to {\n    transform: translateY(5px)\n  }\n}\n\n.rcw-messages-container {\n  background-color: #fff;\n  height: 50vh;\n  max-height: 410px;\n  overflow-y: scroll;\n  padding-top: 10px;\n  -webkit-overflow-scrolling: touch\n}\n\n.rcw-full-screen .rcw-messages-container {\n  height: 100%;\n  max-height: none\n}\n\n@media screen and (max-width:800px) {\n  .rcw-messages-container {\n    height: 100%;\n    max-height: none\n  }\n}\n\n.rcw-sender {\n  align-items: flex-end !important;\n  background-color: #f4f7f9 !important;\n  border-radius: 0 0 10px 10px !important;\n  display: flex !important;\n  height: -webkit-max-content !important;\n  height: -moz-max-content !important;\n  height: max-content !important;\n  max-height: 95px !important;\n  min-height: 45px !important;\n  overflow: hidden !important;\n  padding: 10px !important;\n  position: relative !important;\n}\n\nbody {\n  letter-spacing: inherit;\n  line-height: inherit;\n}\n\n.rcw-sender.expand {\n  height: 55px\n}\n\n.rcw-new-message {\n  background-color: #fff !important;\n  border: 0 !important;\n  border-radius: 5px !important;\n  padding: 10px 5px !important;\n  resize: none !important;\n  width: calc(100% - 75px) !important;\n}\n\n.rcw-new-message:focus {\n  outline: none\n}\n\n.rcw-new-message.expand {\n  height: 40px\n}\n\n.rcw-input {\n  display: block;\n  height: 100%;\n  line-height: 20px;\n  max-height: 78px;\n  overflow-y: auto;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  -webkit-user-modify: read-write !important;\n  -webkit-line-break: after-white-space !important;\n  color: #222;\n  outline: inherit;\n  outline-offset: inherit;\n  box-shadow: inherit;\n}\n\n.rcw-input.focus-visible,\n.rcw-input:focus-visible {\n  outline: none !important;\n}\n\n.rcw-input[placeholder]:empty:before {\n  content: attr(placeholder) !important;\n  color: grey !important;\n}\n\na:empty,\nul:empty,\ndl:empty,\ndiv:empty,\nsection:empty,\narticle:empty,\np:empty,\nh1:empty,\nh2:empty,\nh3:empty,\nh4:empty,\nh5:empty,\nh6:empty {\n  display: inherit;\n}\n\n.rcw-picker-btn,\n.rcw-send {\n  background: #f4f7f9;\n  border: 0;\n  cursor: pointer\n}\n\n.rcw-picker-btn .rcw-send-icon,\n.rcw-send .rcw-send-icon {\n  height: 25px\n}\n\n.rcw-message-disable {\n  background-color: #f4f7f9;\n  cursor: not-allowed\n}\n\n@media screen and (max-width:800px) {\n  .rcw-sender {\n    border-radius: 0;\n    flex-shrink: 0\n  }\n}\n\n.quick-buttons-container {\n  background: #fff;\n  overflow-x: auto;\n  white-space: nowrap;\n  padding: 10px\n}\n\n.quick-buttons-container .quick-buttons {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: center\n}\n\n.quick-buttons-container .quick-buttons .quick-list-button {\n  display: inline-block;\n  margin-right: 10px\n}\n\n@media screen and (max-width:800px) {\n  .quick-buttons-container {\n    padding-bottom: 15px\n  }\n}\n\n.emoji-mart,\n.emoji-mart * {\n  box-sizing: border-box;\n  line-height: 1.15\n}\n\n.emoji-mart {\n  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;\n  font-size: 16px;\n  display: inline-block;\n  color: #222427;\n  border: 1px solid #d9d9d9;\n  border-radius: 5px;\n  background: #fff\n}\n\n.emoji-mart .emoji-mart-emoji {\n  padding: 6px\n}\n\n.emoji-mart-bar {\n  border: 0 solid #d9d9d9\n}\n\n.emoji-mart-bar:first-child {\n  border-bottom-width: 1px;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px\n}\n\n.emoji-mart-bar:last-child {\n  border-top-width: 1px;\n  border-bottom-left-radius: 5px;\n  border-bottom-right-radius: 5px\n}\n\n.emoji-mart-anchors {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 0 6px;\n  line-height: 0\n}\n\n.emoji-mart-anchor {\n  position: relative;\n  display: block;\n  flex: 1 1 auto;\n  color: #858585;\n  text-align: center;\n  padding: 12px 4px;\n  overflow: hidden;\n  transition: color .1s ease-out;\n  margin: 0;\n  box-shadow: none;\n  background: none;\n  border: none\n}\n\n.emoji-mart-anchor:focus {\n  outline: 0\n}\n\n.emoji-mart-anchor-selected,\n.emoji-mart-anchor:focus,\n.emoji-mart-anchor:hover {\n  color: #464646\n}\n\n.emoji-mart-anchor-selected .emoji-mart-anchor-bar {\n  bottom: 0\n}\n\n.emoji-mart-anchor-bar {\n  position: absolute;\n  bottom: -3px;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #464646\n}\n\n.emoji-mart-anchors i {\n  display: inline-block;\n  width: 100%;\n  max-width: 22px\n}\n\n.emoji-mart-anchors img,\n.emoji-mart-anchors svg {\n  fill: currentColor;\n  height: 18px;\n  width: 18px\n}\n\n.emoji-mart-scroll {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 270px;\n  padding: 0 6px 6px;\n  will-change: transform\n}\n\n.emoji-mart-search {\n  margin-top: 6px;\n  padding: 0 6px;\n  position: relative\n}\n\n.emoji-mart-search input {\n  font-size: 16px;\n  display: block;\n  width: 100%;\n  padding: 5px 25px 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #d9d9d9;\n  outline: 0\n}\n\n.emoji-mart-search input,\n.emoji-mart-search input::-webkit-search-cancel-button,\n.emoji-mart-search input::-webkit-search-decoration,\n.emoji-mart-search input::-webkit-search-results-button,\n.emoji-mart-search input::-webkit-search-results-decoration {\n  -webkit-appearance: none\n}\n\n.emoji-mart-search-icon {\n  position: absolute;\n  top: 7px;\n  right: 11px;\n  z-index: 2;\n  padding: 2px 5px 1px;\n  border: none;\n  background: none\n}\n\n.emoji-mart-category .emoji-mart-emoji span {\n  z-index: 1;\n  position: relative;\n  text-align: center;\n  cursor: default\n}\n\n.emoji-mart-category .emoji-mart-emoji:hover:before {\n  z-index: 0;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f4f4f4;\n  border-radius: 100%\n}\n\n.emoji-mart-category-label {\n  z-index: 2;\n  position: relative;\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0\n}\n\n.emoji-mart-category-label span {\n  display: block;\n  width: 100%;\n  font-weight: 500;\n  padding: 5px 6px;\n  background-color: #fff;\n  background-color: hsla(0, 0%, 100%, .95)\n}\n\n.emoji-mart-category-list {\n  margin: 0;\n  padding: 0\n}\n\n.emoji-mart-category-list li {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: inline-block\n}\n\n.emoji-mart-emoji {\n  position: relative;\n  display: inline-block;\n  font-size: 0;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  box-shadow: none\n}\n\n.emoji-mart-emoji-native {\n  font-family: Segoe UI Emoji, Segoe UI Symbol, Segoe UI, Apple Color Emoji, Twemoji Mozilla, Noto Color Emoji, Android Emoji\n}\n\n.emoji-mart-no-results {\n  font-size: 14px;\n  text-align: center;\n  padding-top: 70px;\n  color: #858585\n}\n\n.emoji-mart-no-results-img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  width: 50%\n}\n\n.emoji-mart-no-results .emoji-mart-category-label {\n  display: none\n}\n\n.emoji-mart-no-results .emoji-mart-no-results-label {\n  margin-top: .2em\n}\n\n.emoji-mart-no-results .emoji-mart-emoji:hover:before {\n  content: none\n}\n\n.emoji-mart-preview {\n  position: relative;\n  height: 70px\n}\n\n.emoji-mart-preview-data,\n.emoji-mart-preview-emoji,\n.emoji-mart-preview-skins {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%)\n}\n\n.emoji-mart-preview-emoji {\n  left: 12px\n}\n\n.emoji-mart-preview-data {\n  left: 68px;\n  right: 12px;\n  word-break: break-all\n}\n\n.emoji-mart-preview-skins {\n  right: 30px;\n  text-align: right\n}\n\n.emoji-mart-preview-skins.custom {\n  right: 10px;\n  text-align: right\n}\n\n.emoji-mart-preview-name {\n  font-size: 14px\n}\n\n.emoji-mart-preview-shortname {\n  font-size: 12px;\n  color: #888\n}\n\n.emoji-mart-preview-emoticon+.emoji-mart-preview-emoticon,\n.emoji-mart-preview-shortname+.emoji-mart-preview-emoticon,\n.emoji-mart-preview-shortname+.emoji-mart-preview-shortname {\n  margin-left: .5em\n}\n\n.emoji-mart-preview-emoticon {\n  font-size: 11px;\n  color: #bbb\n}\n\n.emoji-mart-title span {\n  display: inline-block;\n  vertical-align: middle\n}\n\n.emoji-mart-title .emoji-mart-emoji {\n  padding: 0\n}\n\n.emoji-mart-title-label {\n  color: #999a9c;\n  font-size: 26px;\n  font-weight: 300\n}\n\n.emoji-mart-skin-swatches {\n  font-size: 0;\n  padding: 2px 0;\n  border: 1px solid #d9d9d9;\n  border-radius: 12px;\n  background-color: #fff\n}\n\n.emoji-mart-skin-swatches.custom {\n  font-size: 0;\n  border: none;\n  background-color: #fff\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch {\n  width: 16px;\n  padding: 0 2px\n}\n\n.emoji-mart-skin-swatches.opened .emoji-mart-skin-swatch.selected:after {\n  opacity: .75\n}\n\n.emoji-mart-skin-swatch {\n  display: inline-block;\n  width: 0;\n  vertical-align: middle;\n  transition-property: width, padding;\n  transition-duration: .125s;\n  transition-timing-function: ease-out\n}\n\n.emoji-mart-skin-swatch:first-child {\n  transition-delay: 0s\n}\n\n.emoji-mart-skin-swatch:nth-child(2) {\n  transition-delay: .03s\n}\n\n.emoji-mart-skin-swatch:nth-child(3) {\n  transition-delay: .06s\n}\n\n.emoji-mart-skin-swatch:nth-child(4) {\n  transition-delay: .09s\n}\n\n.emoji-mart-skin-swatch:nth-child(5) {\n  transition-delay: .12s\n}\n\n.emoji-mart-skin-swatch:nth-child(6) {\n  transition-delay: .15s\n}\n\n.emoji-mart-skin-swatch.selected {\n  position: relative;\n  width: 16px;\n  padding: 0 2px\n}\n\n.emoji-mart-skin-swatch.selected:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  margin: -2px 0 0 -2px;\n  background-color: #fff;\n  border-radius: 100%;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity .2s ease-out\n}\n\n.emoji-mart-skin-swatch.custom {\n  display: inline-block;\n  width: 0;\n  height: 38px;\n  overflow: hidden;\n  vertical-align: middle;\n  transition-property: width, height;\n  transition-duration: .125s;\n  transition-timing-function: ease-out;\n  cursor: default\n}\n\n.emoji-mart-skin-swatch.custom.selected {\n  position: relative;\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0\n}\n\n.emoji-mart-skin-swatch.custom.selected:after {\n  content: \"\";\n  width: 0;\n  height: 0\n}\n\n.emoji-mart-skin-swatches.custom .emoji-mart-skin-swatch.custom:hover {\n  background-color: #f4f4f4;\n  border-radius: 10%\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom {\n  width: 36px;\n  height: 38px;\n  padding: 0 2px 0 0\n}\n\n.emoji-mart-skin-swatches.custom.opened .emoji-mart-skin-swatch.custom.selected:after {\n  opacity: .75\n}\n\n.emoji-mart-skin-text.opened {\n  display: inline-block;\n  vertical-align: middle;\n  text-align: left;\n  color: #888;\n  font-size: 11px;\n  padding: 5px 2px;\n  width: 95px;\n  height: 40px;\n  border-radius: 10%;\n  background-color: #fff\n}\n\n.emoji-mart-skin {\n  display: inline-block;\n  width: 100%;\n  padding-top: 100%;\n  max-width: 12px;\n  border-radius: 100%\n}\n\n.emoji-mart-skin-tone-1 {\n  background-color: #ffc93a\n}\n\n.emoji-mart-skin-tone-2 {\n  background-color: #fadcbc\n}\n\n.emoji-mart-skin-tone-3 {\n  background-color: #e0bb95\n}\n\n.emoji-mart-skin-tone-4 {\n  background-color: #bf8f68\n}\n\n.emoji-mart-skin-tone-5 {\n  background-color: #9b643d\n}\n\n.emoji-mart-skin-tone-6 {\n  background-color: #594539\n}\n\n.emoji-mart-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0\n}\n\n.emoji-mart-dark {\n  color: #fff;\n  background-color: #222\n}\n\n.emoji-mart-dark,\n.emoji-mart-dark .emoji-mart-bar {\n  border-color: #555453\n}\n\n.emoji-mart-dark .emoji-mart-search input {\n  color: #fff;\n  border-color: #555453;\n  background-color: #2f2f2f\n}\n\n.emoji-mart-dark .emoji-mart-search-icon svg {\n  fill: #fff\n}\n\n.emoji-mart-dark .emoji-mart-category .emoji-mart-emoji:hover:before {\n  background-color: #444\n}\n\n.emoji-mart-dark .emoji-mart-category-label span {\n  background-color: #222;\n  color: #fff\n}\n\n.emoji-mart-dark .emoji-mart-skin-swatches {\n  border-color: #555453;\n  background-color: #222\n}\n\n.emoji-mart-dark .emoji-mart-anchor-selected,\n.emoji-mart-dark .emoji-mart-anchor:focus,\n.emoji-mart-dark .emoji-mart-anchor:hover {\n  color: #bfbfbf\n}\n\n.rcw-conversation-container {\n  border-radius: 10px;\n  box-shadow: 0 2px 10px 1px #b5b5b5;\n  min-width: 370px;\n  max-width: 90vw;\n  position: relative\n}\n\n.rcw-conversation-container.active {\n  opacity: 1;\n  transform: translateY(0);\n  transition: opacity .3s ease, transform .3s ease\n}\n\n.rcw-conversation-container.hidden {\n  z-index: -1;\n  pointer-events: none;\n  opacity: 0;\n  transform: translateY(10px);\n  transition: opacity .3s ease, transform .3s ease\n}\n\n.rcw-conversation-resizer {\n  cursor: col-resize;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 5px\n}\n\n.emoji-mart-preview {\n  display: none\n}\n\n.rcw-full-screen .rcw-conversation-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%\n}\n\n@media screen and (max-width:800px) {\n  .rcw-conversation-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%\n  }\n}\n\n.rcw-launcher .rcw-badge {\n  position: fixed;\n  top: -10px;\n  right: -5px;\n  background-color: red;\n  color: #fff;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  line-height: 25px;\n  border-radius: 50%\n}\n\n.rcw-launcher {\n  -webkit-animation-delay: 0;\n  -webkit-animation-duration: .5s;\n  -webkit-animation-name: slide-in;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-delay: 0;\n  -moz-animation-duration: .5s;\n  -moz-animation-name: slide-in;\n  -moz-animation-fill-mode: forwards;\n  animation-delay: 0;\n  animation-duration: .5s;\n  animation-name: slide-in;\n  animation-fill-mode: forwards;\n  align-self: flex-end;\n  border: 0;\n  border-radius: 50%;\n  box-shadow: 0 2px 10px 1px #b5b5b5;\n  height: 60px;\n  margin-top: 10px;\n  cursor: pointer;\n  width: 60px\n}\n\n.rcw-launcher:focus {\n  outline: none\n}\n\n.rcw-open-launcher {\n  -webkit-animation-delay: 0;\n  -webkit-animation-duration: .5s;\n  -webkit-animation-name: rotation-rl;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-delay: 0;\n  -moz-animation-duration: .5s;\n  -moz-animation-name: rotation-rl;\n  -moz-animation-fill-mode: forwards;\n  animation-delay: 0;\n  animation-duration: .5s;\n  animation-name: rotation-rl;\n  animation-fill-mode: forwards\n}\n\n.rcw-close-launcher {\n  width: 20px;\n  -webkit-animation-delay: 0;\n  -webkit-animation-duration: .5s;\n  -webkit-animation-name: rotation-lr;\n  -webkit-animation-fill-mode: forwards;\n  -moz-animation-delay: 0;\n  -moz-animation-duration: .5s;\n  -moz-animation-name: rotation-lr;\n  -moz-animation-fill-mode: forwards;\n  animation-delay: 0;\n  animation-duration: .5s;\n  animation-name: rotation-lr;\n  animation-fill-mode: forwards\n}\n\n@media screen and (max-width:800px) {\n  .rcw-launcher {\n    bottom: 0;\n    margin: 20px;\n    position: fixed;\n    right: 0\n  }\n\n  .rcw-hide-sm {\n    display: none\n  }\n}\n\n.rcw-previewer-container {\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, .75);\n  overflow: hidden;\n  position: fixed;\n  z-index: 9999;\n  left: 0;\n  top: 0\n}\n\n.rcw-previewer-container .rcw-previewer-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  transition: all .3s ease\n}\n\n.rcw-previewer-container .rcw-previewer-tools {\n  position: fixed;\n  right: 16px;\n  bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center\n}\n\n.rcw-previewer-container .rcw-previewer-button {\n  padding: 0;\n  margin: 16px;\n  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, .3);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  background-color: #fff;\n  border: none\n}\n\n.rcw-previewer-container .rcw-previewer-close-button {\n  position: absolute;\n  right: 0;\n  top: 0\n}\n\n.rcw-previewer-container .rcw-previewer-veil {\n  width: 100%;\n  height: 100%;\n  overflow: scroll;\n  position: relative\n}\n\n@-webkit-keyframes rotation-lr {\n  0% {\n    transform: rotate(-90deg)\n  }\n\n  to {\n    transform: rotate(0)\n  }\n}\n\n@keyframes rotation-lr {\n  0% {\n    transform: rotate(-90deg)\n  }\n\n  to {\n    transform: rotate(0)\n  }\n}\n\n@-webkit-keyframes rotation-rl {\n  0% {\n    transform: rotate(90deg)\n  }\n\n  to {\n    transform: rotate(0)\n  }\n}\n\n@keyframes rotation-rl {\n  0% {\n    transform: rotate(90deg)\n  }\n\n  to {\n    transform: rotate(0)\n  }\n}\n\n@-webkit-keyframes slide-in {\n  0% {\n    opacity: 0;\n    transform: translateY(10px)\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0)\n  }\n}\n\n@keyframes slide-in {\n  0% {\n    opacity: 0;\n    transform: translateY(10px)\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0)\n  }\n}\n\n@-webkit-keyframes slide-out {\n  0% {\n    opacity: 1;\n    transform: translateY(0)\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(10px)\n  }\n}\n\n@keyframes slide-out {\n  0% {\n    opacity: 1;\n    transform: translateY(0)\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(10px)\n  }\n}\n\n.rcw-widget-container {\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  margin: 0 20px 20px 0;\n  position: fixed;\n  right: 0;\n  z-index: 9999\n}\n\n.rcw-full-screen {\n  height: 100vh;\n  margin: 0;\n  max-width: none;\n  width: 100%\n}\n\n@media screen and (max-width:800px) {\n  .rcw-widget-container {\n    height: 100%;\n    height: 100vh;\n    margin: 0;\n    max-width: none;\n    width: 100%\n  }\n}\n\n.rcw-previewer .rcw-message-img {\n  cursor: pointer\n}\n\n.rcw-close-widget-container {\n  height: -webkit-max-content;\n  height: -moz-max-content;\n  height: max-content;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
